import { useMemo } from 'react';
import type { Doc } from '@bill-alps/backend/convex/_generated/dataModel';

export function useClientMap(clients: Doc<'clients'>[] | undefined) {
  return useMemo(() => {
    const map = new Map<string, string>();
    if (clients) {
      for (const c of clients) map.set(c._id, c.name);
    }
    return map;
  }, [clients]);
}
